import { render } from "./SlasIndex.vue?vue&type=template&id=7139f36f"
import script from "./SlasIndex.vue?vue&type=script&lang=js"
export * from "./SlasIndex.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__